var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-paper"},[_c('div',{staticClass:"e-paper__title flex"},[_c('img',{attrs:{"src":require("@/assets/images/logo_.png")}}),_c('div',{staticClass:"return_btn"},[_c('button',{staticClass:"btn_primary",on:{"click":_vm.returnLogin}},[_vm._v("返回")])])]),_c('div',{staticClass:"paper_contain"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }